import styled from 'styled-components';

export const DIV = styled.div`
    margin-left: 230px;
    height: 50px;

    @media only screen and (max-width: 480px) { 
        .grid-table {
            margin-left: -230px;
        }
    }

`;